export enum Instance {
    InstanceProd = 1,
    InstanceDev = 2,
    InstanceLocal = 3,
}

export function getInstance(): Instance {
    let instance = 'local';
    if (window.location.hostname.toLowerCase().endsWith('.com')) {
        instance = 'prod'
    } else if (window.location.hostname.toLowerCase().endsWith('.xyz')) {
        instance = 'prod'
    } else if (window.location.hostname.toLowerCase().endsWith('.dev')) {
        instance = 'dev'
    }
    switch (instance) {
        case 'prod':
            return Instance.InstanceProd;
        case 'dev':
            return Instance.InstanceDev;
    }
    return Instance.InstanceLocal;
}

export function getBaseApiUrl(): string {
    const url = window.location.protocol + '//' + window.location.hostname;
    if (window.location.port !== '') {
        return url + ':' + window.location.port + '/api';
    }
    return url + '/api';
}
